var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadingVideoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7163 16.2092L15.0425 13.5342L28 0.57666L40.9575 13.5342L38.2838 16.2092L29.8913 7.81666V38.8771H26.1088V7.81666L17.7163 16.2092ZM51.675 33.4137V45.0387C51.6707 45.1523 51.6235 45.26 51.5431 45.3402C51.4626 45.4204 51.3548 45.4672 51.2413 45.4712H4.70751C4.59973 45.4638 4.49918 45.4143 4.4276 45.3334C4.35603 45.2525 4.31918 45.1466 4.32501 45.0387V33.4137H0.542512V45.0387C0.538183 46.149 0.974133 47.2156 1.75483 48.005C2.53554 48.7944 3.59732 49.2421 4.70751 49.25H51.2413C52.359 49.249 53.4306 48.8046 54.2211 48.0144C55.0115 47.2242 55.4562 46.1527 55.4575 45.035V33.41L51.675 33.4137Z",
    fill: "#ABDBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadingVideoIcon);
export default __webpack_public_path__ + "static/media/uploading-video-icon.97f689c457b4ac871583cdbc93d4c670.svg";
export { ForwardRef as ReactComponent };